import { useTranslation } from 'react-i18next';
import Manage from './components/mange';

const ManageConsent = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="title ">{t('Manage Consent')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Consent Management')} /{' '}
                </span>
                <span> {t('Manage Consent')}</span>
            </div>
            <div>
                <Manage />
            </div>
        </div>
    );
};

export default ManageConsent;
